import {
  isLastBookingInviteDraft,
  bookingHasReschedules,
  bookingWithNoInvite,
} from '../../../common/garageHelpers';
import { sortBookingsByCollectionDateAscending } from '../../../common/helpers';
import isLastBookingInvitePending from './helpers';
import { applyUserSelectedFilters } from '../../../common/garageFilters';

export const getBookingsForColumn = (bookings, columnType) => {
  let filteredBookings = bookings;

  if (columnType === 'draft') {
    filteredBookings = bookings.filter(
      (booking) => isLastBookingInviteDraft(booking) && !bookingHasReschedules(booking)
    );
  }

  if (columnType === 'reschedule') {
    filteredBookings = bookings.filter(
      (booking) => !isLastBookingInviteDraft(booking) && bookingHasReschedules(booking)
    );
  }

  if (columnType === 'pending') {
    filteredBookings = bookings.filter((booking) => isLastBookingInvitePending(booking));
  }

  if (columnType === 'unallocated') {
    filteredBookings = bookings.filter(
      (booking) =>
        (!isLastBookingInviteDraft(booking) &&
          !isLastBookingInvitePending(booking) &&
          !bookingHasReschedules(booking)) ||
        bookingWithNoInvite(booking)
    );
  }

  const sortedBookings = sortBookingsByCollectionDateAscending(filteredBookings);

  return sortedBookings.map((booking) => ({
    template: {},
    booking,
    drivers: [],
    id: `${booking.bookingId} `,
    draggable: false,
  }));
};

export const getColumnsWithBookings = (bookings = [], filters) => {
  const columnTitles = [
    {
      type: 'draft',
      title: 'Draft',
    },
    {
      type: 'reschedule',
      title: 'Reschedules',
    },
    {
      type: 'pending',
      title: 'Shown on Gary (Pending)',
    },
    {
      type: 'unallocated',
      title: 'Unallocated',
    },
  ];

  let filteredBookings;

  if (!filters.filteredGarage) {
    filteredBookings = [];
  } else {
    filteredBookings = applyUserSelectedFilters(bookings, filters);
  }

  return columnTitles.map((column) => {
    const cards = getBookingsForColumn(filteredBookings, column.type);

    return {
      id: column.type,
      title: column.title,
      label: cards.length.toString() || undefined,
      cards,
    };
  });
};
